// extracted by mini-css-extract-plugin
export default {"info":"info--oANRa"};